import React, { useEffect, useState } from 'react';

import { Trans } from 'react-i18next';

import { IBdsTooltip } from '../../../interfaces/bdsTooltip';
import './BdsTooltip.scss';

const BdsTooltip = ({
  message,
  children,
  variant = 'standard',
  position = 'bottom-center',
  containerShape = 'default',
  showPointer = true,
  open,
  subtitle,
  className,
  renderTooltip = true
}: React.PropsWithChildren<IBdsTooltip>) => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (open !== undefined) {
      setVisible(open);
    }
  }, [open]);

  const handleKeyDown = (e: React.KeyboardEvent<HTMLDivElement>) => {
    if (e.key === 'Enter' || e.key === ' ') {
      setVisible((prev) => !prev);
    }
  };

  if (!renderTooltip) {
    return <>{children}</>;
  }

  return (
    <div
      role="button"
      tabIndex={0}
      className={`bds-tooltip ${className}`}
      onMouseEnter={() => setVisible(true)}
      onMouseLeave={() => setVisible(false)}
      onKeyDown={handleKeyDown}
    >
      {children}
      {visible && (
        <div
          className={`tooltip-box ${variant} ${
            subtitle ? 'bold-title' : ''
          } flex flex-col justify-center items-start shape-${containerShape} tooltip-${position} ${
            showPointer ? '' : 'beak-hidden'
          }`}
          data-testid="tooltip-message"
        >
          <Trans
            i18nKey={message}
            components={{
              b: <b></b>
            }}
          />
          {subtitle && <div className="tooltip-subtitle">{subtitle}</div>}
        </div>
      )}
    </div>
  );
};

export default BdsTooltip;
